export default __webpack_public_path__ + "static/media/sweet-spot-2-gsec-fof.8c5e2885.png";